import { Injectable, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DefaultResponseInterface } from '../model/response/default-response.interface';
import { AbstractApiController } from '../../../../../../../modules/api-module/api/abstract-api-controller';
import { Configuration } from '../../../../../../../modules/api-module/configuration';
import { WeeklyExpenseRequest } from '../model/request/weekly-expense.request';

@Injectable()
export class AdminWeeklyExpensesApiService extends AbstractApiController {

  constructor(
    private http: HttpClient,
    @Optional() config?: Configuration
  ) {
    super();
    this.baseUrl = (config && config.apiBaseUrl)
      ? config.apiBaseUrl : 'https://example.com';
  }

  public fetchList(page, limit, order, filter = null) {
    return this.http.get<any>(
      this.prepareListRequest(
        this.baseUrl + '/api/te/admin/v1/weekly-expenses',
        page,
        limit,
        order,
        filter
      ),
      {headers: this.getAuthHeaders()}
    );
  }

  public save(request: WeeklyExpenseRequest) {
    return this.http.post<DefaultResponseInterface>(
      this.baseUrl + '/api/te/admin/v1/weekly-expenses',
      request,
      {headers: this.getAuthHeaders()}
    );
  }

  public update(id, request) {
    return this.http.put<DefaultResponseInterface>(
      this.baseUrl + `/api/te/admin/v1/weekly-expenses/${id}`,
      request,
      {headers: this.getAuthHeaders()}
    );
  }

  public delete(id) {
    return this.http.delete<DefaultResponseInterface>(
      this.baseUrl + `/api/te/admin/v1/weekly-expenses/${id}`,
      {headers: this.getAuthHeaders()}
    );
  }
}
